const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/user/$userId/transactions.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
// User Gamification Transactions
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/user/$userId/transactions")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Point Transactions",
      description: "Page title for the user gamification transactions path"
    })
  }
});